module.exports = __webpack_public_path__ + "img/TrendBioScience.7dbd603a.png";